import styled, { keyframes } from 'styled-components';

const flip = keyframes`
  0% {
    opacity: 0;
    transform: rotateY(-180deg);
  }

  100% {
    opacity: 1;
    transform: rotateY(0deg);
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  transform-style: preserve-3d;
  img {
    display: block;
    width: 100%;
    height: 100%;
    min-height:250px;
    object-fit: cover;
    transform-style: preserve-3d;
    perspective: 1000px;
    animation: ${flip} 0.5s linear ${props => props.delay.toFixed(1)}s backwards;
  }

`;

export const Overlay = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.85);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  color: #fff;
  transition: opacity 0.5s;

  h3 {
    font-size: 1.5em;
    text-align: center;
  }

  hr {
    width: 0;
    transition: width 0.5s ease;
  }
  &:hover {
    opacity: 1;
    hr {
      width: 50%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Thumb/Styles.js